import "./Holdings.css";

const Holdings = ({
  holdings,
  transactions,
  selectedPartner,
  manualLtp,
  setManualLtp,
  calculateInvestment,
  calculateUPL
}) => {

  // ✅ Safety: fallback if structure is not ready yet
  const partnerId = selectedPartner?.id || "all";

  return (
    <div className="bottom-stats">
      {Object.keys(holdings).map((scrip) => {
        const qty = holdings[scrip] || 0;

        // ✅ Always pass selectedPartner object (your updated logic uses .id inside)
        const investment = calculateInvestment(
          transactions,
          scrip,
          selectedPartner
        ) || 0;

        const ltp = manualLtp[scrip] || 0;
        const value = ltp ? (qty * ltp).toFixed(2) : "0.00";

        const upl = ltp
          ? calculateUPL(qty, ltp, investment).toFixed(2)
          : "0.00";

        return (
          <div className="stat-card holding-card" key={scrip}>
            
            {/* ✅ Show partner-aware heading */}
            <h2>
              {scrip}: {qty}
              {partnerId !== "all" && (
                <span className="partner-tag">
                  {" "}({selectedPartner?.name})
                </span>
              )}
            </h2>

            <div className="holding-row">
              <label>LTP:</label>
              <input
                type="number"
                className="ltp-input"
                value={manualLtp[scrip] || ""}
                onChange={(e) =>
                  setManualLtp({
                    ...manualLtp,
                    [scrip]: Number(e.target.value),
                  })
                }
              />
            </div>

            <p>Investment: {Number(investment).toFixed(2)}</p>
            <p>Value: {value}</p>
            <p>UPL: {upl}</p>
          </div>
        );
      })}
    </div>
  );
};

export default Holdings;